import { render, staticRenderFns } from "./Combination.vue?vue&type=template&id=6c928745&scoped=true&"
import script from "./Combination.vue?vue&type=script&lang=js&"
export * from "./Combination.vue?vue&type=script&lang=js&"
import style0 from "./Combination.vue?vue&type=style&index=0&id=6c928745&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c928745",
  null
  
)

export default component.exports